const Skeleton = ({ children }) => {
  return <div className="w-full overflow-hidden">{children}</div>;
};

export default Skeleton;
